import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import CircularProgress from '@mui/material/CircularProgress';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputAdornment from '@mui/material/InputAdornment';

import NumberInput from "./NumberInput.js";

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import { ReactSortable, Sortable, MultiDrag, Swap } from "react-sortablejs";

import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2

import CardMedia from '@mui/material/CardMedia';

import testImage1 from "./test-1.jpeg"
import testImage2 from "./test-2.jpeg"
import testImage3 from "./test-3.jpeg"
import testImage4 from "./test-4.jpeg"
// import testImage5 from "./test-5.jpeg"

import DeleteIcon from '@mui/icons-material/Delete';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import OpenWithIcon from '@mui/icons-material/OpenWith';

import Rotate90DegreesCcwIcon from '@mui/icons-material/Rotate90DegreesCcw';
import Rotate90DegreesCwIcon from '@mui/icons-material/Rotate90DegreesCw';

import Divider from '@mui/material/Divider';

import Camera from "./Camera.js";
import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
    centerAspectCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import TextManager from '../TextManager.js';

// import Switch from '@mui/material/Switch';

export default class ImageCroppingPage extends React.Component {

    state = {
        crop: Crop,

        clippingShadowPositions: { left: 0, top: 0, right: 0, bottom: 0 },

        showProcessingDialog: false,

        thumbnailSrc: null,
    }

    isConfirmed = false;
    rotation = 0;

    componentDidMount() {
        // var image = new Image();
        // image.src = testImage5;

        // image.onload = () => {
            this.setState({
                crop: {
                    unit: "%", // Can be 'px' or '%'
                    x: 0,
                    y: 0,
                    width: 100,
                    height: 100
                },

                thumbnailSrc: this.props.thumbnailSrc,
            });
        // }

        this.isConfirmed = false;
    }

    getClippedImageCanvas(image, x, y, width, height) {
        var canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(image, x, y, width, height, 0, 0, width, height);

        return canvas;
    }

    rotateImage90(image, rotation = 1) {
        var canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");

        if (rotation % 2 == 0) {
            canvas.width = image.width;
            canvas.height = image.height;
        } else {
            canvas.width = image.height;
            canvas.height = image.width;
        }

        //console.log(image.width, image.height)

        ctx.translate(canvas.width * 0.5, canvas.height  * 0.5);
        ctx.rotate((Math.PI / 2) * rotation);
        ctx.translate(-image.width * 0.5, -image.height  * 0.5);
        
        ctx.drawImage(image, 0, 0);

        return canvas;
    }

    rotateThumbnail(rotation) {
        this.rotation += rotation;

        var image = new Image();
        const originalThumbnailUrl = this.state.thumbnailSrc;
        image.src = originalThumbnailUrl;

        image.onload = () => {
            const imageRotated = this.rotateImage90(image, rotation)
            const newUrl = imageRotated.toDataURL("image/png").replace("image/png", "image/octet-stream");

            this.setState({
                thumbnailSrc: newUrl,
            });

            window.URL.revokeObjectURL(originalThumbnailUrl);
        }
    }

    render() {
        return (

            <div className="PopupPage">
                <div className="PageTitle">{TextManager.getText("image_cropping")}</div>

                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "20px",
                    marginBottom: "10px",
                }}>
                    <ReactCrop
                        style={{
                            overflow: "visible",
                            "--left": this.state.clippingShadowPositions.left,
                            "--top": this.state.clippingShadowPositions.top,
                            "--right": this.state.clippingShadowPositions.right,
                            "--bottom": this.state.clippingShadowPositions.bottom,


                        }}
                        keepSelection={true}
                        crop={this.state.crop}

                        onChange={(pixelCrop, percentCrop) => {
                            this.setState({
                                crop: percentCrop,
                                clippingShadowPositions: {
                                    left: percentCrop.x + "%",
                                    top: percentCrop.y + "%",
                                    right: 100 - (percentCrop.width + percentCrop.x) + "%",
                                    bottom: 100 - (percentCrop.height + percentCrop.y) + "%",
                                }
                            });
                        }}

                    >
                        <img style={{ maxHeight: "50vh", minHeight: "400px" }} src={this.state.thumbnailSrc} onError={(event) => this.props.onImageError?.call(this, event)}/>
                    </ReactCrop>
                </Box>

                <Stack direction="row" spacing={2} sx={{
                    justifyContent: "center",
                    alignItems: "center",

                }}>
                    <IconButton onClick={ (e) => {
                        this.rotateThumbnail(-1);
                    } } size="small" sx={{
                        width:"40px",
                        height:"40px",
                        boxShadow: "0 0 4px 0 rgba(0,0,0,0.5)",
                        // border: "1px solid black",
                    }}>
                        <Rotate90DegreesCcwIcon sx={{ color: "rgba(0,130,240,1)", width:"100%", height:"100%"}} />
                    </IconButton>

                    <IconButton onClick={ (e) => {
                        this.rotateThumbnail(1);
                    } } size="small" sx={{
                        width:"40px",
                        height:"40px",
                        boxShadow: "0 0 4px 0 rgba(0,0,0,0.5)",
                        // border: "1px solid black",
                    }}>
                        <Rotate90DegreesCwIcon sx={{ color: "rgba(0,130,240,1)", width:"100%", height:"100%"}} />
                    </IconButton>
                </Stack>

                <Typography sx={{
                    textAlign: "center",
                    lineHeight: "20px",
                    fontSize: "20px",
                    marginTop: "10px",
                    marginBottom: "20px"
                }}>
                    {TextManager.getText("crop_guide")}
                </Typography>

                <Stack direction="row" spacing={2} sx={{
                    justifyContent: "center",
                    alignItems: "center",

                }}>
                    <Button variant="contained" onClick={async (e) => {
                        if (this.isConfirmed) {
                            return;
                        }

                        this.isConfirmed = true;

                        this.setState({
                            showProcessingDialog: true
                        });

                        //////////////////////////////////
                        const thumbnailUrl = this.state.thumbnailSrc;
                        const imageUrl = this.props.imageSrc;

                        let event = new Event("onImageClippingFinished");

                        const uncroppedThumbnail = new Image();
                        uncroppedThumbnail.src = thumbnailUrl;

                        const uncroppedImage = new Image();
                        uncroppedImage.src = imageUrl;

                        //////////////////////////////////

                        var thumbnailCroppingTask = new Promise( (resolve, reject) => {
                            uncroppedThumbnail.onload = () => {
                                const crop = this.state.crop;

                                let canvas = this.getClippedImageCanvas(
                                    uncroppedThumbnail,
                                    crop.x * uncroppedThumbnail.width / 100, crop.y * uncroppedThumbnail.height / 100,
                                    crop.width * uncroppedThumbnail.width / 100, crop.height * uncroppedThumbnail.height / 100
                                );

                                const croppedThumbnailUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
                                event.thumbnailUrl = croppedThumbnailUrl;

                                resolve();
                            }
                        });

                        var imageCroppingTask = new Promise( (resolve, reject) => {
                            uncroppedImage.onload = () => {

                                const crop = this.state.crop;

                                const imageRotated = this.rotateImage90(uncroppedImage, this.rotation);

                                let canvas = this.getClippedImageCanvas(
                                    imageRotated,
                                    crop.x * imageRotated.width / 100, crop.y * imageRotated.height / 100,
                                    crop.width * imageRotated.width / 100, crop.height * imageRotated.height / 100
                                );

                                // console.log(this.rotation);
                                // const canvasRotated = this.rotateImage90(canvas, this.rotation);

                                canvas.toBlob((blob) => {
                                    let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                                    event.canvas = canvas;
                                    event.file = file;
                                    
                                    resolve();
                                    
                                }, "image/jpeg", 0.5);
                                
                                // let clippedImageUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                                // const a = document.createElement("a");
                                // document.body.appendChild(a);
                                // a.style = "display: none";
                                // a.href = clippedImageUrl;
                                // a.download = "photo.jpeg";
                                // a.click();

                                
                            };
                        });

                        await thumbnailCroppingTask;
                        await imageCroppingTask;

                        this.props.onImageClippingFinished?.call(this, event);
                        this.props.close()

                        this.setState({
                            showProcessingDialog: false
                        });

                    }}>{TextManager.getText("confirm")}</Button>
                    <Button variant="contained" onClick={()=>this.props.close()}>{TextManager.getText("cancel")}</Button>
                </Stack>

                <Dialog open={this.state.showProcessingDialog} >
					<Box sx={{
						margin: "50px 50px",
					}}>
						<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
							<CircularProgress disableShrink />
							<Typography>{TextManager.getText("processing")}</Typography>
						</Stack>
					</Box>
				</Dialog>
            </div>
        );
    }
}